import { memo } from "react";
import * as styles from "./setting-card.module.css";

export const SettingCard = memo(function SettingCard(props: {
  children?: React.ReactNode;
}) {
  return <div className={styles.container}>{props.children}</div>;
});
